import * as Config from "../../configuration";
import * as FilterSearchDefault from "./FeralScan/FilterSearch";
import * as FilterSearchPlatypus from "./Platypus/FilterSearch";
import { FilterState } from "../../reducers/filter.reducer";
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { IAppState } from "../../app";
import * as FilterActionCreators from "../../actions/filter.actions";
import * as DashboardActionCreators from "../../actions/dashboard.actions";
import * as DataActionCreators from "../../actions/data.actions";


interface IFilterSearchContainerActions {
    updateFilters?: typeof FilterActionCreators.applyFilter;
    saveFilter?: typeof DashboardActionCreators.saveFilterRequest;
    search?: typeof DataActionCreators.searchRequest;
    getQuestions?: typeof DashboardActionCreators.getQuestionReferenceDataRequest;
}

interface IFilterSearchContainerPropsMapped {
    filter?: FilterState;
    referenceData?: any;
}

interface IFilterSearchContainerProps {
    classificationFilter: string;
    currentUser: any;
    onFilterChanged: any;
    showFilters: any;
    queryDateStart?: string;
    queryDateEnd?: string;
    queryCommunityGroupId?: number;

    show?: boolean;
    theme?: string;
}

type FilterSearchContainerPropsAndActions = IFilterSearchContainerProps & IFilterSearchContainerPropsMapped & IFilterSearchContainerActions;


class FilterSearchContainer extends React.Component<FilterSearchContainerPropsAndActions, any> {
    constructor(props: FilterSearchContainerPropsAndActions, context) {
        super(props, context);

        this.saveFilter = this.saveFilter.bind(this);
    }

    async saveFilter(preferences, filters) {

        //const { currentZoom, currentLat, currentLng } = this.state;
        var newPreferences = { ...preferences };
        newPreferences.defaultLatitude = undefined; //currentLat;
        newPreferences.defaultLatitude = undefined; //currentLng;
        newPreferences.defaultLatitude = undefined; //currentZoom;

        this.props.saveFilter(newPreferences, filters);
    }

    render() {
        
        const FilterSearchComponent = process.env.PRODUCT === Config.productFeralscan
        ? FilterSearchDefault
        : FilterSearchPlatypus;


        return <FilterSearchComponent.default
            classificationFilter={this.props.classificationFilter}
            currentUser={this.props.currentUser}
            filter={this.props.filter}
            getQuestions={this.props.getQuestions}
            onFilterChanged={this.props.onFilterChanged}
            queryCommunityGroupId={this.props.queryCommunityGroupId}
            queryDateStart={this.props.queryDateStart}
            queryDateEnd={this.props.queryDateEnd}
            referenceData={this.props.referenceData}
            saveFilter={this.saveFilter}
            search={this.props.search}
            showFilters={this.props.showFilters}
            updateFilters={this.props.updateFilters}
            show={this.props.show}
        />;
    }
}


const mapStateToProps = (state: IAppState, ownProps: FilterSearchContainerPropsAndActions): IFilterSearchContainerPropsMapped => {

    return {
        filter: state.filter,
        referenceData: state.referenceData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateFilters: FilterActionCreators.applyFilter,
        save: DashboardActionCreators.saveFilterRequest,
        search: DataActionCreators.searchRequest,
        getQuestions: DashboardActionCreators.getQuestionReferenceDataRequest,
    }, dispatch)
}

export default connect(mapStateToProps,mapDispatchToProps)(FilterSearchContainer);